<template>
    <div>
        <div id="modal" class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-content">
                <div class="box">
                    <article class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <img  :src="provider.logo"  alt="Image">
                            </figure>
                        </div>
                        <div class="media-content">
                            <div class="content">
                                <div>
                                    <h3 class="headline mb-0">{{ provider.name }}</h3>
                                    <div>Numero {{ call.from }}</div>
                                </div>
                            </div>
                            <form v-if="onCall" @submit.prevent="hangup">
                                <FormInput v-model="name"
                                           name="name"
                                           label="Nombre del cliente"
                                           required></FormInput>
                                <FormInput v-model="comments"
                                           name="comments"
                                           label="Commentarios"
                                           hint="Escribir comentarios adicionales durante la llamada"></FormInput>
                                <button type="submit" class="button is-success">Terminar Llamada</button>
                            </form>
                            <a class="button is-primary" @click.once="connectCall"  v-if="! onCall && !loading">Responder llamada</a>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Timer from 'easytimer'
    import Twilio from '@twilio/voice-sdk'
    import {Device} from '@twilio/voice-sdk'

    export default {
        name: "CallModal",
        props: {
            call: Object,
            provider: Object
        },
        data() {
            return {
                device: null,
                time: null,
                timer: new Timer(),
                onCall: false,
                ready: true,
                error: null,
                comments: '',
                name: '',
                loading: false,
                errors: {},
                success: false,
                ringing: false
            }
        },
        methods: {
            prepareComponent() {
            },
            setCall(conn) {
                let call = conn.parameters.CallSid
                this.success = true
                console.log(conn)
                this.loading = false
                this.onCall = true
                this.timer.start();
                this.timer.addEventListener('secondsUpdated', e => {
                    this.time = this.timer.getTimeValues().toString()
                });
            },
            updateAllDevices() {
                var speakerDevices = document.getElementById('speaker-devices');
                var ringtoneDevices = document.getElementById('ringtone-devices');
                this.updateDevices(speakerDevices, this.device.audio.speakerDevices.get());
                this.updateDevices(ringtoneDevices, this.device.audio.ringtoneDevices.get());
            },
            updateDevices(selectEl, selectedDevices) {
                selectEl.innerHTML = '';
                this.device.audio.availableOutputDevices.forEach(function (device, id) {
                    var isActive = (selectedDevices.size === 0 && id === 'default');
                    selectedDevices.forEach(function (device) {
                        if (device.deviceId === id) {
                            isActive = true;
                        }
                    });

                    var option = document.createElement('option');
                    option.label = device.label;
                    option.setAttribute('data-id', id);
                    if (isActive) {
                        option.setAttribute('selected', 'selected');
                    }
                    selectEl.appendChild(option);
                });
            },
            connectCall() {
                this.ringing = false;
                this.getToken()
            },
            getToken() {
                this.loading = true
                this.$http.post('/ivr/token').then(response => {
                    this.listenerTwilio(response.data).then(() => {
                        Device.connect()
                    })
                })
            },
            listenerTwilio(token) {
                return new Promise((resolve, reject) => {
                    Device.setup(token);

                    Device.ready(device => {
                        this.ready = device
                    })

                    Device.connect(conn => {

                        setTimeout(() => {
                            this.setCall(conn)
                        }, 3000)

                    });

                    Device.error(error => {
                        this.error = error.message
                        this.success = false
                        this.loading = false
                    })

                    Device.disconnect(conn => {
                        let call = conn.parameters.CallSid
                        this.onCall = false
                        this.timer.stop()
                        let data = {
                            comments: this.comments,
                            name: this.name,
                            call_sid: call
                        };
                        this.$http.post('/ivr/update_call', data);
                        this.name = ''
                        this.comments = ''
                        this.$emit('hangup');
                    });

                    setTimeout(() => {
                        resolve()
                    }, 300)
                })
            },
            hangup() {
                this.$http.post('/ivr/hangup')
            },
            startRinging(){
                const audio = new Audio('/sounds/alarm.mp3');
                this.ringing = true;
                this.doRing(audio);
            },
            doRing(audio){
                audio.play();
                setTimeout(() => {
                    if(this.ringing && this.$auth.user().uuid){

                        this.doRing(audio);
                    }
                }, 500)
            }
        }
    }
</script>

<style scoped>

</style>
